export const BASE_URL = 'https://ebaybaymo-server-b084d082cda7.herokuapp.com/';
